module.exports = __webpack_public_path__ + "static/media/mastercard.3678c9c0.svg";